import type { EventVenueMap } from "@tih/shared";
import { useEventContent } from "../../context/EventContentContext";
import {
  venueAddressLines,
  venueDirectionsUrlFrom,
  venueMapEmbedUrlFrom,
} from "../../lib/coming-soon-venue";

type Props = {
  /** Override context venueMap (e.g. coming-soon boot payload). */
  venueMap?: EventVenueMap | null;
};

export function ComingSoonDirections({ venueMap: venueMapProp }: Props = {} as Props) {
  const content = useEventContent();
  const venue = venueMapProp !== undefined ? venueMapProp : content.venueMap ?? null;
  if (!venue) return null;

  const directionsUrl = venueDirectionsUrlFrom(venue);
  const embedUrl = venueMapEmbedUrlFrom(venue);
  const lines = venueAddressLines(venue);

  return (
    <div className="coming-soon-map-band" id="directions">
      <div className="coming-soon-map-inner">
        <div className="coming-soon-map-copy">
          <div className="coming-soon-map-eyebrow">
            <span className="rule" />
            <span>Find us</span>
            <span className="rule" />
          </div>
          <h2 className="coming-soon-map-title">{venue.name}</h2>
          <p className="coming-soon-map-address">
            {lines.map((line, i) => (
              <span key={`${line}-${i}`}>
                {i > 0 ? <br /> : null}
                {line}
              </span>
            ))}
          </p>
          <a
            href={directionsUrl}
            className="btn btn-primary coming-soon-map-cta"
            target="_blank"
            rel="noopener noreferrer"
          >
            Get directions
            <span className="arr">↗</span>
          </a>
          <p className="coming-soon-map-fallback">
            Map not loading?{" "}
            <a href={directionsUrl} target="_blank" rel="noopener noreferrer">
              Open in Google Maps
            </a>
          </p>
        </div>
        <div className="coming-soon-map-frame">
          <iframe
            title={`Map: ${venue.name}`}
            className="coming-soon-map-iframe"
            src={embedUrl}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            allowFullScreen
          />
        </div>
      </div>
    </div>
  );
}
